import ClampedTextWithTooltip from "./ClampedTextWithTooltip";

export default ClampedTextWithTooltip;
